module.exports = __webpack_public_path__ + "img/bg.10704d76.jpg";